import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { JfwPasswordValidator } from '@jfw/angular/shared/common-components/form-fields';
import { Subject, switchMap, tap } from 'rxjs';
import { PlatformUserService } from '../../services/platform-user/platform-user.service';
import MatchValidation from './validators/match.validator';

type PasswordForm = {
  password: FormControl<string>;
  confirmPassword: FormControl<string>;
};

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    CommonModule,
  ],
})
export class CreatePasswordComponent {
  private platformUserService = inject(PlatformUserService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  public form = new FormGroup<PasswordForm>(
    {
      password: new FormControl('', {
        validators: [
          Validators.required,
          Validators.minLength(10),
          JfwPasswordValidator.isValid(),
        ],
        nonNullable: true,
      }),
      confirmPassword: new FormControl('', {
        validators: [
          Validators.required,
          Validators.minLength(10),
          JfwPasswordValidator.isValid(),
        ],
        nonNullable: true,
      }),
    },
    { validators: MatchValidation.match('password', 'confirmPassword') },
  );

  public passwordCtrl = this.form.controls.password;
  public confirmPasswordCtrl = this.form.controls.confirmPassword;

  public hidePassword = true;

  public formSubmit = new Subject<void>();

  public formSubmitResponse$ = this.formSubmit.pipe(
    switchMap(() => {
      const firestoreId = this.activatedRoute.snapshot.params.firestoreId;
      const password = this.passwordCtrl.value;

      return this.platformUserService
        .registerEmailUser(firestoreId, password)
        .pipe(
          tap((response) => {
            if (response.success) {
              this.router.navigate(['/sign-in']);
            }
          }),
        );
    }),
  );
}
